import { InstrumentName } from "soundfont-player";
import { RydExternalMidiInstrument, RydInstrument, RydInstrumentFactory, RydSFInstrument, RydVirtualInstrument } from "../../model/instrument";
import { TrackOutputType } from "../../model/tracks";
import { AudioSink } from "../routing";
import { au } from "react-router/dist/development/route-data-B9_30zbP";

export function mapToInstrument({
    trackOutputType,
    vInstrument,
    sfInstrument,
    midiSink,
    // trackInstrument,
    audioContext
}: {
    trackOutputType: TrackOutputType,
    vInstrument?: RydInstrumentFactory,
    sfInstrument?: InstrumentName,
    midiSink?: AudioSink,
    // trackInstrument?: RydInstrument,
    audioContext: AudioContext
}): RydInstrument | undefined {

    switch (trackOutputType) {
        case 'VSYNTH':
            if (vInstrument) {
                return vInstrument.create(audioContext);
            }
            break
        case 'SF2':
            if (sfInstrument) {
                const i = new RydSFInstrument(sfInstrument, `SF ${sfInstrument}`, sfInstrument, audioContext);
                return i;
            }
            break;
        case 'EXTMIDI':
            if (midiSink) {
                const m = new RydExternalMidiInstrument(midiSink.id, midiSink.displayName, midiSink);
                m.midiOutput = midiSink;
                return m;
            }
            break;
        default:
            break;
    }

    return undefined;
}